import Package from './Package'

Vue.prototype.$state.$package = new Vue(Package)

Vue.component('resource-packable', () => import(/* webpackChunkName: "resource-packable" */ '@modulesPages/Package/Resources/assets/js/Components/ResourcePackable'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Package\\Entities\\Package': 'Package',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Package\\Entities\\Package': 'packages',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'packages': 'Modules\\Package\\Entities\\Package',
	}	
}